/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PutPharmacyCounselingBoothRequestBodyTypename = "PutPharmacyCounselingBoothRequestBody" as const;

/**
 *
 * @export
 * @interface PutPharmacyCounselingBoothRequestBody
 */
export interface PutPharmacyCounselingBoothRequestBody {
  /**
   *
   * @type {number}
   * @memberof PutPharmacyCounselingBoothRequestBody
   */
  counselingBoothCount?: number;
  /**
   *
   * @type {string}
   * @memberof PutPharmacyCounselingBoothRequestBody
   */
  counselingBoothName?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutPharmacyCounselingBoothRequestBody
   */
  readonly __typename?: string;
}

export function PutPharmacyCounselingBoothRequestBodyFromJSON(json: any): PutPharmacyCounselingBoothRequestBody {
  return PutPharmacyCounselingBoothRequestBodyFromJSONTyped(json, false);
}

export function PutPharmacyCounselingBoothRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutPharmacyCounselingBoothRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutPharmacyCounselingBoothRequestBodyTypename,

    counselingBoothCount: !exists(json, "counseling_booth_count") ? undefined : json["counseling_booth_count"],
    counselingBoothName: !exists(json, "counseling_booth_name") ? undefined : json["counseling_booth_name"],
  };
}

export function PutPharmacyCounselingBoothRequestBodyToJSON(
  object?: PutPharmacyCounselingBoothRequestBody | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    counseling_booth_count: value.counselingBoothCount,
    counseling_booth_name: value.counselingBoothName,
  };
}
